import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AudioRecorder from "../components/AudioRecorder";
import PlayAudioModal from "../components/PlayAudioModal";
import BasicSwitches from "../components/Toggle";
import TheAudioRecorder from "../components/TheAudioRecorder";
import SuggestionsCarousel from "../components/SuggestionsCarousel.tsx";
import { useSnackbar } from "notistack";
import copy from "copy-to-clipboard";
import Typewriter from "typewriter-effect";
import {
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

// (higher is slower)
const languageDelay = {
  english: 51,
  malayalam: 45,
  hindi: 50,
  bengali: 50,
  kannada: 50,
  marathi: 50,
  tamil: 50,
  telugu: 50,
  gujurati: 50,
  punjabi: 50,
  default: 50,
};

const HomePage = ({
  languageCode,
  setLanguageCode,
  handleRecordingComplete,
  loading,
  setLoading,
  handleClear,
  guestOrUser,
  requestStats,
  showResults,
  showSuggestions,
  userTranscription,
  queryTranslation,
  helperText,
  setHelperText,
  setShowSuggestions,
  audioData,
  audioKey,
  setMalayalam,
  malayalam,
  setShowTranslateButton,
  showTranslateButton,
  english,
  siteLanguage,
  setSiteLanguage,
  translations,
  subscriptionStatus,
  languageOptions,
  languageCodes,
  setVoiceGender,
  voiceGender,
  isPulsating,
  setIsPulsating,
  setRecording,
  recording,
  setIsReadyClicked,
  isReadyClicked,
  handleRefresh,
  QueryHistory,
  getNavProps,
  sendErrorToServer,
  setShowQuestionHistory,
  showQuestionHistory,
  guestNumber,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  const handleCopy = () => {
    copy(malayalam);
    enqueueSnackbar("Copied!", { variant: "success" });
  };

  const [width, setWidth] = useState(window.innerWidth);
  // Determining if mobile or not
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  const audioRef = useRef();
  const typewriterRef = useRef();

  const [selectLanguageText, setSelectLanguageText] = useState("");
  const [selectVoiceText, setSelectVoiceText] = useState("");
  const [showPlayAudioModal, setShowPlayAudioModal] = useState(false);
  const [iosStatus, setIosStatus] = useState(null);
  const [showMalayalamText, setShowMalayalamText] = useState(false);
  const [showHelperText, setShowHelperText] = useState(true);

  // when the audio is finished playing, close the PlayAudioModal
  const handlePlayAudioModalClose = () => {
    setShowPlayAudioModal(false);
    setIsReadyClicked(true);
    setShowMalayalamText(true);
  };

  const navigate = useNavigate();
  const { language } = useParams(); // retrieving the language parameter
  const validLanguages = Object.values(languageOptions);

  useEffect(() => {
    const initialLanguageCode = languageCodes[language];
    if (initialLanguageCode && validLanguages.includes(language)) {
      setLanguageCode(initialLanguageCode);
      setSiteLanguage(language);
    } else if (!validLanguages.includes(language)) {
      navigate(`/${siteLanguage}`);
    }
    setIosStatus(isIOS());
  }, []);

  const handleLanguageChange = (event) => {
    // console.log("siteLanguageHP", siteLanguage);
    // console.log("helperTextHP", helperText);
    const newLanguageCode = event.target.value;
    setLanguageCode(newLanguageCode);

    setSiteLanguage(languageOptions[newLanguageCode]);
    setHelperText(translations[siteLanguage].language);

    handleClear();
    navigate(`/${languageOptions[newLanguageCode]}`);
  };

  useEffect(() => {
    setSelectLanguageText(translations[siteLanguage].selectLanguage);
    setSelectVoiceText(translations[siteLanguage].selectVoice);
  }, [siteLanguage]);

  const handleVoiceGenderChange = (event) => {
    setVoiceGender(event.target.value);
  };

  useEffect(() => {
    if (showResults) {
      setShowPlayAudioModal(true);
      setShowMalayalamText(false);
    }
  }, [showResults]);

  return (
    <div className="App">
      {/* <div>Your user # is {guestNumber.id}!</div> */}
      <div
        style={{
          position: "absolute",
          top: isMobile ? "11px" : "9px", // adjust this value to position it further from the top
          right: isMobile ? "7px" : "8px", // adjust this value to position it further from the right
          display: "flex",
          alignItems: "center",
          gap: "10px",
          // backgroundColor: "#fff",
          padding: isMobile ? "0px" : "6px",
          // borderRadius: "10px",
          // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <span style={{ fontWeight: "bold", color: "white" }}>
          Question History
        </span>

        <BasicSwitches
          setToggleState={setShowQuestionHistory}
          customColor="white"
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          color: "black",
          marginTop: "8px",
          // backgroundColor: "#f4dad5",
          // backgroundColor: "#f2e1dd",541b14
          // padding: isMobile ? "0px" : "6px",
          // padding: "0px 15px",
          // borderRadius: "50px",
          // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <span style={{ fontWeight: "bold", color: "black" }}>Instructions</span>

        <BasicSwitches setToggleState={setShowHelperText} customColor="white" />
      </div>
      {showHelperText && <h1 style={{ textAlign: "center" }}>{helperText}</h1>}
      {!showHelperText && <p></p>}
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginBottom: "30px",
          // marginTop: "10px",
        }}
      >
        <FormControl
          variant="outlined"
          style={{ minWidth: "150px", marginRight: "10px" }}
        >
          <InputLabel style={{ fontSize: "16px" }} id="language-select-label">
            {selectLanguageText}
          </InputLabel>
          <Select
            labelId="language-select-label"
            value={languageCode}
            onChange={handleLanguageChange}
            label="Select Language"
          >
            {Object.entries(languageOptions).map(([code, name]) => (
              <MenuItem key={code} value={code}>
                {name.charAt(0).toUpperCase() + name.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" style={{ minWidth: "100px" }}>
          <InputLabel
            style={{ fontSize: "16px" }}
            id="voice-gender-select-label"
          >
            {selectVoiceText}
          </InputLabel>
          <Select
            labelId="voice-gender-select-label"
            value={voiceGender}
            onChange={handleVoiceGenderChange}
            label="Select Voice Gender"
          >
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
          </Select>
        </FormControl>
      </div>
      <AudioRecorder
        className="AudioRecorder"
        onRecordingComplete={handleRecordingComplete}
        recordingDisabled={requestStats.count >= requestStats.limit}
        loading={loading}
        setLoading={setLoading}
        handleClear={handleClear}
        setHelperText={setHelperText}
        setShowSuggestions={setShowSuggestions}
        siteLanguage={siteLanguage}
        translations={translations}
        isPulsating={isPulsating}
        setIsPulsating={setIsPulsating}
        audioRef={audioRef}
        setRecording={setRecording}
        recording={recording}
        handleRefresh={handleRefresh}
        iosStatus={iosStatus}
        sendErrorToServer={sendErrorToServer}
      />
      {userTranscription && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginBottom: "-15px",
            width: isMobile ? "95%" : "100%",
          }}
        >
          <p
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: "1rem",
            }}
          >
            <b>Transcription</b>: "{userTranscription}"
          </p>
        </div>
      )}
      {languageCode === "ml-IN" && queryTranslation && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: isMobile ? "95%" : "100%",
            marginBottom: "-35px",
          }}
        >
          <p
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: "1rem",
            }}
          >
            <b>Translation</b>: "{queryTranslation}"
          </p>
        </div>
      )}
      {/* The below details credit usage */}
      {/* {guestOrUser === "guest" && (
        <div className="requestStats">
          {translations[siteLanguage].freeQuestions}:{" "}
          {requestStats.limit - requestStats.count}
        </div>
      )}

      {guestOrUser === "user" && !subscriptionStatus && (
        <div className="requestStats">
          Credits: {requestStats.count}/{requestStats.limit}
        </div>
      )} */}
      {/* The above details credit usage */}
      {requestStats.count >= requestStats.limit &&
        guestOrUser === "user" &&
        subscriptionStatus === false && (
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/subscribe"
            sx={{ mt: 2, backgroundColor: "#541b14" }}
          >
            Subscribe
          </Button>
        )}
      {requestStats.count >= requestStats.limit && guestOrUser === "guest" && (
        <div className="register-invite">
          <p>Want 25 more questions?</p>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/register"
            sx={{ mt: 2, backgroundColor: "#541b14" }}
          >
            Create FREE Account
          </Button>
        </div>
      )}
      {showResults && (
        <>
          {isMobile && !isReadyClicked ? (
            <PlayAudioModal
              showPlayAudioModal={showPlayAudioModal}
              handlePlayAudioModalClose={handlePlayAudioModalClose}
              isMobile={isMobile}
              isReadyClicked={isReadyClicked}
              siteLanguage={siteLanguage}
            />
          ) : (
            <div className="AudioData">
              <div className="AudioData__audio">
                <audio
                  ref={audioRef}
                  controls
                  key={audioKey}
                  autoPlay={!isMobile || (isMobile && isReadyClicked)}
                >
                  <source
                    src={`data:audio/mp3;base64,${audioData}`}
                    type="audio/mp3"
                  />
                  Your browser does not support the audio element.
                </audio>
              </div>
              <div className="AudioData__text">
                {
                  !iosStatus ? (
                    <Typewriter
                      onInit={(typewriter) => {
                        typewriterRef.current = typewriter;
                        if (!isMobile || (isMobile && isReadyClicked))
                          typewriter.start();
                      }}
                      options={{
                        strings: malayalam,
                        autoStart: !isMobile || (isMobile && isReadyClicked),
                        loop: false,
                        delay:
                          languageDelay[siteLanguage] ||
                          languageDelay["default"],
                        skipAddStyles: true,
                      }}
                    />
                  ) : null
                  // <div
                  //   style={{
                  //     display: "flex",
                  //     justifyContent: "center",
                  //     alignItems: "center",
                  //   }}
                  // >
                  //   <Button
                  //     sx={{
                  //       backgroundColor: "#1976D2", // specify the background color
                  //       color: "white", // specify the color of the text
                  //       "&:hover": {
                  //         backgroundColor: "#1976D2", // specify the background color on hover
                  //       },
                  //       width: showMalayalamText ? "120px" : "200px",
                  //       marginRight: showMalayalamText ? "10px" : "0",
                  //     }}
                  //     onClick={() => setShowMalayalamText(!showMalayalamText)}
                  //   >
                  //     {showMalayalamText ? "Hide text" : "Show text"}
                  //   </Button>
                  //   {showMalayalamText && (
                  //     <Button
                  //       sx={{
                  //         backgroundColor: "#43A047",
                  //         color: "white",
                  //         width: "70px",
                  //         height: "37px",
                  //         "&:active": {
                  //           backgroundColor: "#43A047",
                  //         },
                  //       }}
                  //       onClick={handleCopy}
                  //     >
                  //       Copy
                  //     </Button>
                  //   )}
                  // </div>
                }
              </div>
              {showMalayalamText && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      width: "90%",
                      textAlign: "center",
                      fontSize: "1.1rem",
                      // marginTop: "-15px",
                    }}
                  >
                    {malayalam}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* {(!isMobile &&
            !isReadyClicked &&
            languageCode == "ml-IN" &&
            showTranslateButton) ||
          (isMobile &&
            isReadyClicked &&
            languageCode == "ml-IN" &&
            showTranslateButton) ? (
            <Button
              sx={{
                backgroundColor: "black",
                color: "white",
                "&:hover": {
                  backgroundColor: "#541b14",
                },
                width: "200px",
                marginBottom: "32px",
              }}
              onClick={() => {
                setMalayalam(english);
                setShowTranslateButton(false);
              }}
            >
              Translate
            </Button>
          ) : null} */}
          {(!isMobile && !isReadyClicked) || (isMobile && isReadyClicked) ? (
            <Button
              sx={{
                backgroundColor: "black", // specify the background color
                color: "white", // specify the color of the text
                "&:hover": {
                  backgroundColor: "#541b14", // specify the background color on hover
                },
                width: "200px",
                marginBottom: "32px",
              }}
              onClick={handleClear}
            >
              Start Over
            </Button>
          ) : null}

          {isMobile && showPlayAudioModal && (
            <PlayAudioModal
              showPlayAudioModal={showPlayAudioModal}
              handlePlayAudioModalClose={handlePlayAudioModalClose}
              isMobile={isMobile}
              isReadyClicked={isReadyClicked}
              siteLanguage={siteLanguage}
            />
          )}
        </>
      )}
      {showQuestionHistory && (
        <QueryHistory
          getNavProps={getNavProps}
          sendErrorToServer={sendErrorToServer}
          audioData={audioData}
        />
      )}
    </div>
  );
};

export default HomePage;
